module.exports = __webpack_public_path__ + "static/index/img/baikal-905.69023c9e.jpg";